import BaseModel from './BaseModel';
import moment from 'moment';

/** Class representing a cron task interval. */
class CronTaskInterval extends BaseModel {
    constructor(properties) {
        super(properties);

        if (this.from)
            this.from = moment(this.from);
        if (this.to)
            this.to = moment(this.to);
    }
}

export default CronTaskInterval;
